import styled from "styled-components";
import geometryImage from "../../assets/svg/geometryImage.svg";
import geometryImage2 from "../../assets/svg/geometryImage2.svg";
import theme from "../../styles/theme";

export const Image = styled.div`
  height: 100%;
  width: 100%;
  background-position: center;
  background-size: cover;
  font-weight: ${theme.fontBold};
  background-position-y: bottom;

  @keyframes slideinbackground {
    from {
      margin-left: -100%;
    }

    to {
      margin-left: 0%;
    }
  }

  @media (orientation: landscape) {
    background-image: url(${({ src }) => src && src[0]});

    .background-color {
      background-image: url(${geometryImage2});
      width: 100%;
      background-repeat: no-repeat;
      height: 100%;
      background-size: contain;
      position: absolute;
      display: flex;
      align-items: center;
      mix-blend-mode: multiply;
    }
  }

  @media (orientation: portrait) {
    background-image: url(${({ src }) => src && src[1]});

    .background-color {
      background-image: url(${geometryImage});
      width: 100%;
      background-repeat: no-repeat;
      height: 47%;
      background-size: contain;
      position: absolute;
      display: flex;
      align-items: center;
      mix-blend-mode: multiply;
      bottom: 0;
      background-size: cover;
      left: 0;
    }
  }
`;
